import { GridContainer, GridItem } from '../index'
import PropTypes from 'prop-types'
import React from 'react'

export default function PanelRow (props) {
  const { md, sm, children } = props
  let mdPantalla = md
  let smPantalla = sm
  if (sm === null) {
    smPantalla = 1
  }
  if (md === null) {
    mdPantalla = 1
  }

  return (
    <GridContainer>
      <GridItem xs={1} sm={smPantalla} md={mdPantalla} />
      {children}
      <GridItem xs={1} sm={smPantalla} md={mdPantalla} />
    </GridContainer>
  )
}

PanelRow.propTypes = {
  md: PropTypes.number,
  children: PropTypes.node
}
